export default "__VITE_ASSET__DfLcF9XF__"